<template>
	<div class="page">
		<div v-if="!nullOrder">
			<div class="main_top">
				<div class="info_tiele">
					{{orderData.Product.ProductName}}
				</div>
				<div style="clear:both;margin-bottom: 0.9375rem;"></div>

				<div class="info_box">
					<div class="">
						<div class="text1">
							承保年龄
						</div>
						<div class="text2">
							{{orderData.AgeRange}}
						</div>
					</div>

					<el-divider direction="vertical"></el-divider>

					<div class="">
						<div class="text1">
							起保日期
						</div>
						<div class="text2">
							{{orderData.StartTime[0]}}
						</div>
					</div>
				</div>

				<div class="info_box">
					<div class="">
						<div class="text1">
							保障天数
						</div>
						<div class="text2">
							{{orderData.Prices.DayRange}}
						</div>
					</div>

					<el-divider direction="vertical"></el-divider>

					<div class="">
						<div class="text1">
							电子邮箱
						</div>
						<div class="text2">
							{{orderData.Email}}
						</div>
					</div>
					<el-divider direction="vertical"></el-divider>
					<div class="">
						<div class="text1">
							旅行目的地
						</div>
						<div class="text2">
							{{orderData.Destination}}
						</div>
					</div>
				</div>


			</div>

			<div class="main_bottom">
				<div class="info_tiele">
					被保人信息
				</div>
				<div style="clear:both;margin-bottom: 0.9375rem;"></div>
				<div class="item" v-for="(item,index) in InsuranceList" :key="index">
					<div class="">
						姓名： {{item.CName}}
					</div>
					<div class="">
						证件号码： {{item.CardNo}}
						<span class="InsuranceInfoItemText">
							{{item.CardType == 1 ? '身份证' : '护照'}}
						</span>
					</div>
				</div>
			</div>

			<div class="btn_box" v-if="orderData.Status != 1">
				<div class="">
					应付金额
					<span id="">
						￥
					</span>
					<span id="">
						{{orderData.Price}}
					</span>
				</div>
				<div id="">
					<el-button type="primary" @click="pay">立即支付</el-button>
				</div>
			</div>
		</div>

		<div class="" v-if="nullOrder">
			<el-empty description="暂无数据" :image-size="230"></el-empty>
		</div>

		<paydialog v-if="!nullOrder" :paytypeVisible="paytypeVisible" :cashAmount="orderData.Price" :orderId="orderId"
			@onClosed="payClosed" @payBack="payBack" :paytype="2">

		</paydialog>
	</div>
</template>

<script>
	import paydialog from "../../components/paydialog/paydialog.vue";
	const util = require('../../util.js');
	export default {
		components: {
			paydialog
		},
		data() {
			return {
				orderId: '',
				orderData: null,
				InsuranceList: [],
				paytypeVisible: false,
				nullOrder: false,
			};
		},
		created() {
			let {
				order
			} = this.$route.query;
			this.orderId = order
			this.getInsuranceOrderDetail(order)
		},
		methods: {
			payClosed() {
				this.paytypeVisible = false;
			},

			payBack() {
				this.$router.push('/orderlist?active=1')
			},

			pay(e, type = 'W01') {
				this.paytypeVisible = true
			},

			getInsuranceOrderDetail(orderId) {
				this.$api.InsuranceOrderDetail({
					orderId
				}).then(res => {
					let {
						data,
						status,
					} = res.data;
					if (status == 200) {
						data.StartTime = data.StartTime.split(" ")
						this.orderData = data;
						this.InsuranceList = data.Detail;
					} else {
						this.nullOrder = true
					}
					console.log(res)
				}).catch(err => {
					this.nullOrder = true
					console.log(err)
				})
			}
		},
		updated() {

		}
	}
</script>

<style lang='less' scoped>
	.page {
		&>div {
			width: 75rem;
			margin: 1.25rem auto;
			min-height: 35rem;
			background-color: #fff;

			.info_tiele {
				font-size: 1.5rem;
				font-weight: 600;
				float: left;
				position: relative;
				display: inline-block;
				z-index: 10;
			}

			.info_tiele:before {
				content: "";
				display: block;
				width: 100%;
				background: linear-gradient(90deg, rgba(90, 153, 255, 1.0), rgba(255, 255, 255, .5));
				height: 0.375rem;
				position: absolute;
				bottom: 0;
				z-index: -1;
				border-radius: 12px;
			}

			.main_top {
				padding: 1.25rem;



				.info_box {
					display: flex;
					align-items: center;
					margin-top: 1.25rem;
					text-align: left;
					margin-bottom: 2rem;

					.el-divider--vertical {
						margin: 0 5rem;
						height: 3em;
						width: 0.0625rem !important;
					}

					&>div {
						width: 7.5rem;

						.text1 {
							font-size: 0.875rem;
							color: #999;
							margin-bottom: 0.75rem;
						}

						.text2 {
							font-size: 1rem;
							color: #000;
						}
					}
				}
			}

			.main_bottom {
				padding: 1.25rem;

				.item {
					width: 80%;
					height: 5.25rem;
					background-color: #f9f9f9;
					border-radius: 1.2rem;
					display: flex;
					align-items: flex-start;
					justify-content: space-around;
					flex-direction: column;
					padding: 1.25rem 1.25rem 1.25rem 2.25rem;
					margin-bottom: 1.25rem;

					.InsuranceInfoItemText {
						display: inline-block;
						padding: 0.2125rem 0.525rem;
						background-color: #ff8033;
						font-size: 1rem;
						margin-left: 0.3125rem;
						color: #fff;
					}
				}
			}

			.btn_box {
				display: flex;
				align-items: center;
				justify-content: space-between;
				padding: 1.25rem;

				&>div:nth-child(1) {
					font-size: 1.25rem;
					font-weight: 600;

					span:nth-child(1) {
						color: #ff8033;
						font-size: 0.875rem;
						font-weight: inherit;
					}

					span:nth-child(2) {
						color: #ff8033;
						font-size: 1.25rem;
						font-weight: 600;
					}
				}

				.el-button {
					padding: 0.925rem 2.175rem;
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/page/Insurance/InsuranceDetail.vue